// frontend/src/components/grid/InheritedCellRenderer.jsx
//
// Shared AG Grid cell renderer for a value that cascades by reference — a
// row-level override over a parent's default (Store → Supplier planning
// fields, pages/supplierPlanningColumns.js). Sibling of OverrideCellRenderer,
// which answers the engine-vs-merchant question for a NUMBER; this one renders
// whatever `formatValue` returns (a label, a weekday, a formatted count), so
// one renderer serves a select column and a number column alike.
//
//   muted text     — the row inherits: what it shows is the parent's value
//   override ink   — the row holds its own value (`override-cell-user`)
//
// Required cellRendererParams:
//   formatValue(value, row) → string   — render a wire value for display
//   effectiveValue(row)     → value    — the resolved reading (`effective_*`)
//   isOverridden(row)       → boolean  — the row's OWN answer (raw column
//                                        non-null), never a comparison of
//                                        values: a merchant who pins the
//                                        parent's own figure has still
//                                        overridden it (see
//                                        utils/safetyStockColDef.js).

import './OverrideCellRenderer.css';

const EM_DASH = '—';

export default function InheritedCellRenderer({ data, node, formatValue, effectiveValue, isOverridden }) {
  // A grouped grid's product row inherits nothing: the setting is each row's own.
  if (!data || node?.group) return null;
  const effective = effectiveValue(data);
  const text = effective === null || effective === undefined
    ? EM_DASH : formatValue(effective, data);
  if (!isOverridden(data)) {
    return <span className="override-cell-auto">{text}</span>;
  }
  return <span className="override-cell-user">{text}</span>;
}
